export default {
  scanner1: {
    id: 'scanner1',
    label: 'Scanner 1',
    firebaseDir: 'scanner1',
    cardClass: 'background__green',
    type: 'scanner',
    count_new_status: 0,
    count_error_status: 0,
    description: "Numérisation à l'aide du Scanner 1",
  },
  scanner2: {
    id: 'scanner2',
    label: 'Scanner 2',
    firebaseDir: 'scanner2',
    cardClass: 'background__blue',
    type: 'scanner',
    count_new_status: 0,
    count_error_status: 0,
    description: "Numérisation à l'aide du Scanner 2",
  },
  scanner3: {
    id: 'scanner3',
    label: 'Scanner 3',
    firebaseDir: 'scanner3',
    cardClass: 'background__red',
    type: 'scanner',
    count_new_status: 0,
    count_error_status: 0,
    description: "Numérisation à l'aide du Scanner 3",
  },
  'app-membre': {
    id: 'app-membre',
    label: 'App SAM',
    firebaseDir: 'app-membre',
    isAppMembre: true,
    cardClass: 'background__validation',
    type: 'validation',
    count_new_status: 0,
    count_error_status: 0,
    description: 'Coupons soumis par les chauffeurs',
  },
} as const;
